<template>
	<!-- Sistema principal - usuário logado -->
	<div id="app" v-if="isLogado">
		<div class="wrapper" :class="{ toggled: isMobile ? mobileMenuOpen : sidebarCollapsed, 'sidebar-hovered': !isMobile && sidebarCollapsed && sidebarHovered }">
			<div class="body-loading" v-if="loadingCount > 0">
				<span class="loader"></span>
			</div>

         <!-- Menu Lateral -->
         <Lateral :collapsed="sidebarCollapsed" :mobile="isMobile" @toggle="alternarSidebar" @hover="sidebarHovered = $event" />

			<!-- Menu NavBar -->
         <NavBar :mobile="isMobile" :menu-open="mobileMenuOpen" @toggle-menu="alternarSidebar" />
			
			<!-- Corpo sistema -->
			<div class="page-wrapper">
				<div class="page-content">
               <div id="tab-content">
                  <div>
                     <ul class="nav nav-header mb-0" v-if="tabsSecaoAtiva.length > 1">
                        <li class="nav-item" v-for="(tab, index) in tabsSecaoAtiva" :key="index">
                           <router-link class="nav-link" :to="tab.path" :class="[tab.path === $route.path ? 'active' : '', index == 0 ? 'pe-3' : '']" @click.native="ativarTabSecao(tab.indiceOriginal)">
                              <span>
                                 <i :class="tab.icon"></i>{{ tab.nome }}
                              </span>
                           </router-link>
                        </li>
                     </ul>
                  </div>
               </div>

               <div id="main-content" :class="tabsSecaoAtiva.length > 1 ? '' : 'main-content2'">
                  <router-view/>
               </div>
				</div>

				<a href="#" class="back-to-top" aria-label="Voltar ao topo" @click.prevent="voltarAoTopo"><i class='bx bxs-up-arrow-alt'></i></a>
			</div>

			<div class="overlay" @click="mobileMenuOpen = false"></div>
			

         <!-- Painel do cliente com eventos e persistência locais em Vue. -->
         <aside class="switcher-wrapper" :class="{ 'switcher-toggled': themePanelOpen }" aria-label="Preferências de aparência" @keydown.esc="themePanelOpen = false">
            <button type="button" class="switcher-btn" title="Personalizar aparência" aria-label="Personalizar aparência" :aria-expanded="String(themePanelOpen)" aria-controls="appearance-panel" @click="themePanelOpen = !themePanelOpen"><i class="bx bx-cog bx-spin" aria-hidden="true"></i></button>
            <div id="appearance-panel" class="switcher-body" v-if="themePanelOpen">
               <div class="d-flex align-items-center"><h5 class="mb-0 text-uppercase">Tema</h5><button type="button" class="btn-close ms-auto close-switcher" aria-label="Fechar aparência" @click="themePanelOpen = false"></button></div>
               <hr>
               <h6 class="mb-0"><i class="far fa-palette color-theme font-13 me-1"></i> Estilo</h6>
               <hr>
               <div class="row row-cols-2 m-0 align-items-center">
                  <div v-for="option in themeOptions" :key="option.value" class="form-check pe-1"><input class="form-check-input" type="radio" name="appearance-style" :id="`style-${option.value}`" :value="option.value" :checked="theme === option.value" @change="selecionarTema(option.value)"><label class="form-check-label ps-1" :for="`style-${option.value}`">{{ option.label }}</label></div>
               </div>
               <hr>
               <h6 class="mb-0"><i class="far fa-paint-brush color-theme font-13 me-1"></i> Cor</h6>
               <hr>
               <div class="header-colors-indigators">
                  <div class="row row-cols-auto g-3">
                     <template v-for="(palette, index) in paletteOptions">
                        <div v-if="index === 24" :key="`${palette.value}-group`" class="w-100 theme-palette-label">Combinações do azul principal</div>
                        <div class="col" :key="palette.value"><button type="button" class="indigator appearance-palette" :class="palette.value" :title="palette.label" :aria-label="palette.label" :aria-pressed="String(themeColor === palette.value)" @click="selecionarCor(palette.value)"><i v-if="themeColor === palette.value" class="far fa-check" aria-hidden="true"></i></button></div>
                     </template>
                  </div>
               </div>
            </div>
         </aside>
		</div>
	</div>

	<!-- Login - usuário não logado -->
	<div id="app" class="logout" v-else>
		<!-- Page Loader -->
		<div class="body-loading" v-if="loadingCount > 0">
			<span class="loader"></span>
		</div>

		<Login />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import Login from '@/views/Login.vue'
import NavBar from '@/components/MenuNavBar.vue'
import Lateral from '@/components/MenuLateral.vue'
import { getVersionFromChangelog } from '@/config/version.js'
import { themeOptions, paletteOptions } from '@/config/appearance'
import { canUserAccessPath } from '@/services/commercial/panelPermissions'

export default {
   name: 'App',
   components: { NavBar, Login, Lateral },
   data() {
      const savedTheme = localStorage.getItem('jair_theme')
      const savedColor = localStorage.getItem('jair_theme_color')
      return {
         theme: themeOptions.some(option => option.value === savedTheme) ? savedTheme : 'light-theme',
         themeColor: paletteOptions.some(option => option.value === savedColor) ? savedColor : 'headercolor1',
         themeOptions, paletteOptions,
         themePanelOpen: false,
         sidebarCollapsed: localStorage.getItem('jair_sidebar_collapsed') === '1',
         sidebarHovered: false,
         mobileMenuOpen: false,
         isMobile: window.matchMedia('(max-width: 1024px)').matches,
         version: 'Carregando...'
      }
   },
   computed: {
      ...mapState({
         loadingCount: state => state.loadingCount,
         isLogado: state => state.isLogado,
         secaoAtiva: state => state.secaoAtiva,
         secoes: state => state.secoes,
         dadosUsuario: state => state.dadosUsuario
      }),
      tabsSecaoAtiva() {
         const secao = this.secoes[this.secaoAtiva]
         if (!secao) return []
         const tabs = secao.tabs.map((tab, indiceOriginal) => ({ ...tab, indiceOriginal }))
            .filter(tab => (tab.role === null || (this.dadosUsuario && this.dadosUsuario.entityType === tab.role)) && canUserAccessPath(this.dadosUsuario, tab.path))
         return tabs.length > 1 ? tabs : []
      }
   },
   watch: {
      '$route'() { this.mobileMenuOpen = false; this.sidebarHovered = false },
      isLogado() { this.mobileMenuOpen = false; this.themePanelOpen = false; this.sidebarHovered = false }
   },
   methods: {
      ativarTabSecao(tabIndex) { this.$store.dispatch('ativarTab', { secao: this.secaoAtiva, tabIndex }) },
      alternarSidebar() {
         if (this.isMobile) { this.mobileMenuOpen = !this.mobileMenuOpen; return }
         this.sidebarCollapsed = !this.sidebarCollapsed
         this.sidebarHovered = false
         localStorage.setItem('jair_sidebar_collapsed', this.sidebarCollapsed ? '1' : '0')
      },
      atualizarViewport(event) { this.isMobile = event.matches; this.mobileMenuOpen = false; this.sidebarHovered = false },
      aplicarAparencia() {
         const html = document.documentElement
         html.classList.remove(...themeOptions.map(option => option.value), ...paletteOptions.map(option => option.value))
         html.classList.add(this.theme, 'color-header', this.themeColor)
      },
      selecionarTema(value) { this.theme = value; localStorage.setItem('jair_theme', value); this.aplicarAparencia() },
      selecionarCor(value) { this.themeColor = value; localStorage.setItem('jair_theme_color', value); this.aplicarAparencia() },
      voltarAoTopo() { document.getElementById('main-content')?.scrollTo({ top: 0, behavior: 'smooth' }) },
      async carregarVersao() {
         try { this.version = await getVersionFromChangelog() }
         catch (error) { console.error('Erro ao carregar versão:', error); this.version = 'v1.1.0' }
      }
   },
   mounted() {
      this.aplicarAparencia()
      this.viewportQuery = window.matchMedia('(max-width: 1024px)')
      this.viewportQuery.addEventListener('change', this.atualizarViewport)
      this.$store.dispatch('verificarAutoLogin')
      this.carregarVersao()
   },
   beforeDestroy() { this.viewportQuery?.removeEventListener('change', this.atualizarViewport) }
}
</script>
